/**
 * School profile follow-ups — thin wrapper around {@link FollowUpsEditor}.
 */
import { forwardRef, useMemo } from 'react';
import type { ComplianceCreateScope } from '@/features/reports/api/compliance.dto';
import { FollowUpsEditor, type FollowUpsEditorHandle } from '@/features/reports/components/FollowUpsEditor';

export type {
  FollowUpStatus,
  FollowUpReview,
  FollowUpTask,
} from '@/features/reports/components/FollowUpsEditor';

export type SchoolFollowUpsSectionHandle = FollowUpsEditorHandle;

export const SchoolFollowUpsSection = forwardRef<SchoolFollowUpsSectionHandle, { schoolId: string; year: string }>(
  function SchoolFollowUpsSection({ schoolId, year }, ref) {
    const scopeKey = `${schoolId}|${year}`;
    const complianceCreateScope = useMemo((): ComplianceCreateScope | undefined => {
      const yearNum = parseInt(year, 10);
      if (!Number.isFinite(yearNum) || yearNum <= 0) return undefined;
      return { kind: 'school', schoolId, reportingYear: yearNum };
    }, [schoolId, year]);
    return (
      <FollowUpsEditor
        ref={ref}
        scopeKey={scopeKey}
        showInlineAddButton={false}
        complianceCreateScope={complianceCreateScope}
      />
    );
  }
);

SchoolFollowUpsSection.displayName = 'SchoolFollowUpsSection';
